import { render, staticRenderFns } from "./gl.vue?vue&type=template&id=01a0f8fc&"
import script from "./gl.vue?vue&type=script&lang=js&"
export * from "./gl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports